import React from 'react';
import ConnectPage from '../components/ConnectPage';

const GSCConnectPage: React.FC = () => {
  const config = {
    serviceName: 'Google Search Console',
    serviceDisplayName: 'Google Search Console',
    apiBaseUrl: 'https://api.gsc.plexhq.ai',
    routePath: '/connect/gsc',
    storageKeys: {
      email: 'userGscEmail',
      returnUrl: 'mcpGscReturnUrl',
      clientId: 'mcpGscClientId',
      state: 'mcpGscState',
      redirectUri: 'mcpGscRedirectUri',
      codeChallenge: 'mcpGscCodeChallenge',
    },
    messages: {
      requestAccess: 'Claude is requesting access to your Google Search Console data. Click "Connect" to authenticate.',
      directAccessError: 'This page is only accessible through Claude AI. Please add the Google Search Console connector in Claude to authenticate.',
      connectDescription: 'Connect your Google Search Console account to access your site data through Claude AI.',
      connectingMessage: 'Connecting...',
      successMessage: 'Successfully connected to Google Search Console!',
      errorMessage: 'Failed to connect to Google Search Console. Please try again.',
      buttonText: 'Connect Your Search Console Account',
    },
  };

  return <ConnectPage config={config} />;
};

export default GSCConnectPage;
